//防抖
import debounce from './utils/debounce'
//防抖
import throttle from './utils/throttle'
//图片转webp
import webp from './utils/webp'

class directives {
    constructor(opts) {
        this.Vue = opts.vm
        this.init()
    }
    init() {
        webp(this.Vue)
        debounce(this.Vue)
        throttle(this.Vue)
    }
}
export default directives



//////////////////
// WEBPACK FOOTER
// ./node_modules/@mxc/v-directive/index.js
// module id = null
// module chunks = 